<template>
	<HeroComp />
	<ContentComp />
	<ZonaComp />
</template>

<script>
import HeroComp from './components/HeroComp.vue';
import ContentComp from './components/ContentComp.vue';
import ZonaComp from './components/ZonaComp.vue';

export default {
	name: 'App',
	components: {
		HeroComp,
		ContentComp,
		ZonaComp,
	},
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;1,400;1,600;1,800&display=swap');
#app {
	font-family: 'Poppins', sans-serif;
	scroll-behavior: smooth;
}
</style>
